import { render, staticRenderFns } from "./ProgrammTitle.vue?vue&type=template&id=5bd1c150&scoped=true&"
import script from "./ProgrammTitle.vue?vue&type=script&lang=js&"
export * from "./ProgrammTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1c150",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/ProgrammTitle.vue
// module id = null
// module chunks = 